import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useConfirmationModal = () => {
  const { t } = useTranslation('reschedule');
  const { onOpenModal, onResetModal } = useModal();

  const openAcceptConfirmation = (onConfirm) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'confirm',
      title: t('approveModalTitle'),
      contentDescription: t('approveModalDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('approveModalConfirmButton'),
      secondaryButtonText: t('cancelButton'),
      onClickPrimaryButton: () => {
        onConfirm();
        onResetModal();
      },
      onClickSecondaryButton: onResetModal,
    });
  };

  const openRejectConfirmation = (onConfirm) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'cancel',
      title: t('rejectModalTitle'),
      contentDescription: t('rejectModalDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('rejectModalConfirmButton'),
      secondaryButtonText: t('cancelButton'),
      onClickPrimaryButton: () => {
        onConfirm();
        onResetModal();
      },
      onClickSecondaryButton: onResetModal,
    });
  };

  return { openAcceptConfirmation, openRejectConfirmation };
};

export default useConfirmationModal;
